import "./royalDivider.css";
import { GiQueenCrown } from "react-icons/gi";

const RoyalDivider = () => {
  return (
    <div className="royal-divider">
      <span className="divider-line" />
      <div className="divider-crown"><GiQueenCrown /></div>
      <span className="divider-line" />
    </div>
  );
};

export default RoyalDivider;

